<template>
    <div>
            <form @submit.prevent="registerSubmit">
                <google-recaptcha-v3
                    v-on:input="updateRecaptcha"
                    ref="captchaRegister"
                    :site-key="this.$recaptchaKey"
                    id="register_id"
                    action="register"
                ></google-recaptcha-v3>
                <input-with-validation
                    :value="item.email"
                    :title="$t('fields.email')"
                    :name="'email'"
                    :style-class="'form-control'"
                    :type="'email'"
                    :errors="errors"
                    :use-u-i-d="true"
                    :name-type="'placeholder'"
                    @onInput="changeEmail"/>
                <input-with-validation
                    :value="item.password"
                    :title="$t('fields.enter_password')"
                    :name="'password'"
                    :style-class="'form-control'"
                    :type="'password'"
                    :errors="errors"
                    :use-u-i-d="true"
                    :name-type="'placeholder'"
                    @onInput="changePassword"/>
                <password v-model="item.password" @score="updatePasswordScore" :strength-meter-only="true"/>
                <span v-if="item.password && item.password.length > 0" class="password_strength_message">{{password_strength_message}}</span>
                <input-with-validation
                    :value="item.password_confirmation"
                    :title="$t('fields.password_confirmation')"
                    :name="'password_confirmation'"
                    :style-class="'form-control'"
                    :type="'password'"
                    :errors="errors"
                    :use-u-i-d="true"
                    :name-type="'placeholder'"
                    @onInput="changePasswordConfirmation"/>
                <input-with-validation
                    :value="item.accept"
                    :checkboxMessage="$t('fields.i_agree_to_the')"
                    :checkboxMessage2="$t('fields.privacy_policy')"
                    :name="'accept'"
                    :style-class="'regular-checkbox'"
                    :mainDivClass="'checkbox d-inline-flex align-items-center'"
                    :type="'custom-checkbox'"
                    :errors="errors"
                    :use-u-i-d="true"
                    @onInput="changeAccept"
                    @elementClick="$bvModal.show('privacy-modal')"/>

                <button type="submit" :class="submitButtonClass" :disabled="loading">
                    <span v-if="!loading">
                        {{$t('fields.register') }}
                    </span>

                    <div class="spinner-border loading-spinner" role="status" v-if="loading">
                        <span class="sr-only"></span>
                    </div>
                </button>

                <div class="messages">
                    <div class="custom-error-message" v-if="errors && errors.error_message">
                        <p>{{errors.error_message}}</p>
                    </div>

                    <div v-if="verify" class="text-success mt-2" style="display: block">
                        {{$t('general.verify_email_before_login')}}
                    </div>
                </div>
            </form>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import Vue from 'vue';
    import GoogleRecaptchaV3 from "../../components/googlerecaptchav3/GoogleReCaptchaV3";

    export default {
        props: {
            submitButtonClass: {
                type: String,
                required: false,
                default: 'text'
            },
        },
        components: {GoogleRecaptchaV3},
        data() {
            return {
                data: [],
                errors: null,
                verify: false,
                password_strength_message: '',
            }
        },
        created() {
            var app = this;
            app.resetState();
            this.$vueEventBus.$on('clear-errors', function () {
                app.errors = null;
            });
            Vue.set(app.item, 'password', app.item.password);
        },
        mounted() {
            var app = this;
            Vue.set(app.item, 'password', app.item.password);
        },
        computed: {
            ...mapGetters('RegisterSingle', ['item', 'loading']),
        },
        methods: {
            ...mapActions('RegisterSingle', ['register', 'setPassword', 'setPasswordConfirmation', 'setEmail', 'setAccept', 'setgRecaptchaResponse', 'setPasswordScore', 'resetState']),
            changeEmail(event) {
                this.setEmail(event.target.value);
            },
            changePassword(event) {
                this.setPassword(event.target.value);
            },
            changeAccept(event) {
                this.setAccept(event.target.checked ? 1 : 0);
            },
            changePasswordConfirmation(event)
            {
                this.setPasswordConfirmation(event.target.value);
            },
            updateRecaptcha(response) {
                this.setgRecaptchaResponse(response);
            },
            updatePasswordScore(score) {
                let pass_score = parseInt(score);
                this.password_strength_message = this.$t('auth.password_strength_'+pass_score,'');
                this.setPasswordScore(pass_score);
            },
            registerSubmit() {
                this.register().then(response => {
                    this.verify = true;
                    this.changeEmail({'target': {'value': ''}});
                    this.changePassword({'target': {'value': ''}});
                    this.changePasswordConfirmation({'target': {'value': ''}})
                    this.errors = null;
                    this.$refs.captchaRegister.execute();
                })
                    .catch(error => {
                        this.errors = error.response.data.errors;
                        if (typeof this.errors === "undefined") {
                            this.errors = {};
                        }
                        if(error.response.data.error_message) {
                            Vue.set(this.errors,'error_message',error.response.data.error_message);
                        }
                        this.$refs.captchaRegister.execute();
                    })
            }
        }
    }
</script>
